module.exports = __webpack_public_path__ + "Feemonk-0fc11505.webp";